// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"a2898c10","113":"bbf31945","200":"94dd6076","210":"4cd0b15d","523":"8023aac2","706":"e83be57c","708":"afd181aa","770":"c5e8e1e5","845":"fda2be14","852":"5061bf9d","855":"1cf98fb0"}[chunkId] + ".chunk.js";
};